import { useState, useEffect } from 'react';
import { Currency, getCurrencies, getLocale } from '../api';

export function useCurrencies() {
  const [isLoading, setIsLoading] = useState(true);
  const [currencies, setCurrencies] = useState<Currency[]>();
  const [defaultCurrencyCode, setDefaultCurrencyCode] = useState('');
  useEffect(() => {
    const fetchData = async () => {
      const { result: currencies } = await getCurrencies();
      setCurrencies(currencies);
      const localeCurrencyCode = (await getLocale()).country.defaultCurrencyCode;
      setDefaultCurrencyCode(
        currencies.some(({ code }) => code == localeCurrencyCode) ? localeCurrencyCode : 'USD',
      );
      setIsLoading(false);
    };
    fetchData();
  }, []);

  return { isLoading, defaultCurrencyCode, currencies };
}
